module.exports = __webpack_public_path__ + "img/5-4.bf3ac544.svg";